import {StyleteqState} from "../_definitions/styleteq";
import {createSelector} from "reselect/src";
import Special from "../_data/models/Special";
import * as _ from "lodash";

export const mySpecialsSelector = (state: StyleteqState) => state.mySpecials;

export const selectorSpecial =  (state: StyleteqState) => state.mySpecials;
export const selectorLoadingSpecial = (state: StyleteqState) => state.mySpecials.loading;


// WEBPACK FOOTER //
// ./app/client/special/selectors.ts